export default __webpack_public_path__ + "static/home-slider-7-6e692f1d4506de93d8fe90402eeb6bb7.jpg";